<template>
  <div class="modal-container">
    <vxe-form ref="xForm" class="my-form2" title-align="right" title-width="150" :data="formData" :rules="formRules"
              @submit="submitEvent" @reset="cancelEvent">
      <vxe-form-item title="客户名称" field="customerName" span="24">
        <template>
          <div class="input-border">
            <a v-if="!isInit" target="_black" @click="openChooseAccount('customerName')">
              {{ formData.customerName ? formData.customerName : "请选择客户名称" }}
            </a>
            <span v-else>{{formData.customerName}}</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="中转对象" field="middleManName" span="24">
        <template>
          <div class="input-border">
            <a target="_black" @click="openChooseAccount('middleManName')">
              {{ formData.middleManName ? formData.middleManName : "请选择中转对象" }}
            </a>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="费率" field="rate" span="24">
        <template v-slot="scope">
          <vxe-input style="width: 300px;" v-model="formData.rate" type="number" placeholder="请输入费率%"
                     @input="$refs.xForm.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="状态" field="isActive" span="24">
        <template v-slot>
          <vxe-radio-group v-model="formData.isActive">
            <vxe-radio :label="1">启用</vxe-radio>
            <vxe-radio :label="0">禁用</vxe-radio>
          </vxe-radio-group>
        </template>
      </vxe-form-item>
      <vxe-form-item align="center" span="24">
        <template v-slot>
          <vxe-button type="submit" status="primary">确定</vxe-button>
          <vxe-button type="reset">取消</vxe-button>
        </template>
      </vxe-form-item>
    </vxe-form>
    <vxe-modal v-model="isShowChooseAccount" width="800" height="600" resize remember
               :title="currentChoose === 'customerName' ? '客户名称' : '中转对象'">
      <account @choose="chooseAccountEvent" ref="Account"></account>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import $C from "@/consts/index";
  import {showLoading, hideLoading, isEmpty} from "@/utils/util";
  import Auth from "@/utils/auth";
  import Account from '@/components/modal/Account'

  export default {
    name: "CreateTraOnlinePay",
    components: {Account},
    data() {
      let userInfoValue = {};
      if (Auth.isLogin()) {
        userInfoValue = Auth.getAuth();
      }
      return {
        userInfoValue,
        isShowChooseAccount: false,
        currentChoose: '',
        isInit: false,
        formData: {
          customerId: null,
          customerName: null,
          id: null,
          isActive: 1,
          middleManId: null,
          middleManName: null,
          rate: null,
        },
        type: 0,
        formRules: {
          customerName: [{required: true, message: "请选择客户名称"}],
          middleManName: [{required: true, message: "请选择中转对象"}],
          rate: [{required: true, message: "请输入费率"}],
          isActive: [{required: true, message: "请选择状态"}],
        },
      };
    },
    methods: {
      init(obj) {
        this.isInit = true;
        this.formData.customerId = obj.id;
        this.formData.customerName = obj.name;
      },
      setUpdate(row) {
        this.type = 1;
        this.formData = {
          customerId: row.customerId,
          customerName: row.customerName,
          id: row.id,
          isActive: row.isActive,
          middleManId: row.middleManId,
          middleManName: row.middleManName,
          rate: row.rate,
        }
      },
      openChooseAccount(field) {
        this.isShowChooseAccount = true;
        this.currentChoose = field;
        this.$refs.Account.init()
      },
      chooseAccountEvent(account, type) {
        if (this.currentChoose === 'customerName') {
          this.formData.customerId = account.id;
          this.formData.customerName = account.userName;
        } else {
          this.formData.middleManId = account.id;
          this.formData.middleManName = account.userName;
        }
        this.isShowChooseAccount = false
        this.$refs.xForm.clearValidate();
      },
      async queryUserList() {
        let res = await $api.baseUserSign.post("queryUserList", {});
        this.loading = false;
        if (res.status === 1) {
          this.tablePage.total = res.data.total;
          this.tableList = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async submitEvent() {
        showLoading();
        let obj = Object.assign({}, this.formData);
        obj.rate = parseFloat(obj.rate);
        let res = await $api.middleMan.post(this.type === 0 ? 'create' : 'update', obj);
        hideLoading();
        if (res.status === 1) {
          let message = this.type === 0 ? '创建成功！' : '修改成功!';
          this.$XModal.message({message: message});
          this.cancelEvent();
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      cancelEvent() {
        this.type = 0;
        this.isInit = false;
        this.$emit('close');
        this.formData = {
          customerId: null,
          customerName: null,
          id: null,
          isActive: 1,
          middleManId: null,
          middleManName: null,
          rate: null,
        };
      }
    },
  };
</script>

<style scoped>
  .modal-container {
    position: relative;
    height: 100%;
  }

  .input-border {
    border: 1px solid #dcdfe6;
    width: 300px;
    height: 34px;
    border-radius: 4px;
    padding: 0 .6em;
  }

  .input-border a, .input-border span {
    cursor: pointer;
    display: inline-block;
    width: 100%;
    line-height: 34px;
  }
</style>